var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/hashtag.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.to-array.js";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Sparklines, SparklinesCurve } from 'react-sparklines';
import { getSoapboxConfig } from 'soapbox/actions/soapbox';
import { useAppSelector } from 'soapbox/hooks';
import { shortNumberFormat } from '../utils/numbers';
import Permalink from './permalink';
import { HStack, Stack, Text } from './ui';
const Hashtag = ({
  hashtag
}) => {
  const count = Number(hashtag.history?.get(0)?.accounts);
  const brandColor = useAppSelector(state => getSoapboxConfig(state).brandColor);
  return /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    justifyContent: "between",
    "data-testid": "hashtag",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Permalink, {
    href: hashtag.url,
    to: `/tag/${hashtag.name}`,
    className: "hover:underline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    size: "sm",
    weight: "semibold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 11
    }
  }, "#", hashtag.name)), hashtag.history && /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "trends.count_by_accounts",
    defaultMessage: "{count} {rawCount, plural, one {person} other {people}} talking",
    values: {
      rawCount: count,
      count: /*#__PURE__*/React.createElement("strong", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37,
          columnNumber: 24
        }
      }, shortNumberFormat(count))
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 13
    }
  }))), hashtag.history && /*#__PURE__*/React.createElement("div", {
    className: "w-[40px]",
    "data-testid": "sparklines",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Sparklines, {
    width: 40,
    height: 28,
    data: hashtag.history.reverse().map(day => +day.uses).toArray(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(SparklinesCurve, {
    style: {
      fill: 'none'
    },
    color: brandColor,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 13
    }
  }))));
};
export default Hashtag;